export default {
  getAdvertisementPublishPage: (state) => state.advertisement.publishPage,
};
